/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximize budget growth with price change predictions and transfer strategies.`)
};

const es_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximiza el crecimiento de tu presupuesto con predicciones de cambio de precio y estrategias de transferencia.`)
};

const de_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximiere dein Budgetwachstum mit Preisänderungsprognosen und Transferstrategien.`)
};

const nl_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximaliseer je budgetgroei met prijswijzigingsvoorspellingen en transferstrategieën.`)
};

const fr_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximisez la croissance de votre budget avec des prédictions de variation de prix et des stratégies de transfert.`)
};

const it_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massimizza la crescita del budget con previsioni di variazione prezzi e strategie di trasferimento.`)
};

const pt_br2_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximize o crescimento do seu orçamento com previsões de variação de preço e estratégias de transferência.`)
};

const pt_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximize o crescimento do seu orçamento com previsões de variação de preços e estratégias de transferência.`)
};

const ja_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格変動予測と移籍戦略で予算の成長を最大化。`)
};

const zh_f1_home_card_budget_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过价格变动预测和换人策略最大化预算增长。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_card_budget_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_card_budget_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_card_budget_desc", locale)
	if (locale === "en") return en_f1_home_card_budget_desc(inputs)
	if (locale === "es") return es_f1_home_card_budget_desc(inputs)
	if (locale === "de") return de_f1_home_card_budget_desc(inputs)
	if (locale === "nl") return nl_f1_home_card_budget_desc(inputs)
	if (locale === "fr") return fr_f1_home_card_budget_desc(inputs)
	if (locale === "it") return it_f1_home_card_budget_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_card_budget_desc(inputs)
	if (locale === "pt") return pt_f1_home_card_budget_desc(inputs)
	if (locale === "ja") return ja_f1_home_card_budget_desc(inputs)
	return zh_f1_home_card_budget_desc(inputs)
};